export const APP_ENV = import.meta.env.VITE_APP_ENV
export const API_PRIVATE_URL = import.meta.env.VITE_API_PRIVATE_URL
export const API_PUBLIC_URL = import.meta.env.VITE_API_PUBLIC_URL
export const APIM_SUBSCRIPTION_KEY = import.meta.env.VITE_APIM_SUBSCRIPTION_KEY
export const LEGAL_NOTICE = import.meta.env.VITE_APP_LEGAL_NOTICE
export const HELP_URL = import.meta.env.VITE_APP_HELP_URL
export const GOOGLE_TRACKING_ANALYTICS_ID = import.meta.env.VITE_GOOGLE_TRACKING_ANALYTICS_ID
export const ANALYTICS_ENABLED = Boolean(import.meta.env.VITE_ANALYTICS_ENABLED)
export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL || 'INFO'
export const LOG_TRANSPORTS = import.meta.env.VITE_LOG_TRANSPORTS || 'console'
export const AZURE_MAPS_API_KEY = import.meta.env.VITE_AZURE_MAPS_API_KEY
export const APP_VERSION = import.meta.env.VITE_APP_VERSION
